var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgEHeatingSource = function SvgEHeatingSource(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 684,
    height: 480,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Leitungen/L\\xFCftung"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "646.01 283.96 366 283.96 366 295.96 646.01 295.96 646 408 658 408 658 164 646 164 646.01 283.96",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 655,
    y: 164.03,
    width: 1,
    height: 243.97,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "651 288.96 366 288.96 366 290.96 651 290.99 651 408 653 408 653 164 651 164 651 288.96",
    fill: "#df1400"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "648 164.03 649 164 648.97 286.97 366 286.94 366 285.94 648.01 285.94 648 164.03",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "649 292.95 366.01 292.95 366.01 293.95 648 293.95 648 408.01 649 408.01 649 292.95",
    fill: "#787878"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 628,
    y: 408,
    width: 48,
    height: 72,
    fill: "#df1400"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M655.61,456.06c-.18,0-.36-.06-.52-.19-.37-.3-.44-.86-.15-1.25,3.08-4.18,4.24-7.43,3.37-9.42-.39-.88-1.1-1.41-1.92-2.03-1.04-.78-2.22-1.66-2.85-3.39-.74-2.05-.42-4.49.95-7.24.22-.44.73-.6,1.15-.38.42.23.58.77.36,1.2-1.14,2.29-1.43,4.23-.87,5.78.44,1.23,1.32,1.88,2.24,2.57.94.7,1.9,1.42,2.48,2.73,1.19,2.71.02,6.39-3.57,11.26-.17.23-.42.35-.67.35Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.68,456.06c-.18,0-.36-.06-.52-.19-.37-.3-.44-.86-.15-1.25,3.08-4.18,4.24-7.43,3.37-9.42-.39-.88-1.1-1.41-1.92-2.03-1.04-.78-2.22-1.66-2.85-3.39-.74-2.05-.42-4.49.95-7.24.22-.44.73-.6,1.15-.38.42.23.58.77.36,1.2-1.14,2.28-1.43,4.23-.87,5.78.44,1.23,1.32,1.88,2.24,2.57.94.7,1.9,1.42,2.48,2.73,1.19,2.71.02,6.39-3.57,11.26-.17.23-.42.35-.67.35Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.76,456.06c-.18,0-.36-.06-.52-.19-.37-.3-.44-.86-.15-1.25,3.08-4.18,4.24-7.43,3.37-9.42-.39-.88-1.1-1.41-1.92-2.03-1.04-.78-2.22-1.66-2.85-3.39-.74-2.05-.42-4.49.95-7.24.22-.44.73-.6,1.15-.38.42.23.58.77.36,1.2-1.14,2.28-1.43,4.23-.87,5.78.44,1.23,1.32,1.88,2.24,2.57.94.7,1.9,1.42,2.48,2.73,1.19,2.71.02,6.39-3.57,11.26-.17.23-.42.35-.67.35Z",
    fill: "#fff"
  }))))));
};
export default SvgEHeatingSource;